import React from "react";

export const LINK_TYPES = [
  { value: "web", label: "Web" },
  { value: "case", label: "Case study" },
  { value: "mobile", label: "Mobile" },
  { value: "ios", label: "iOS · App Store" },
  { value: "android", label: "Android · Play Store" },
  { value: "github", label: "GitHub" },
  { value: "figma", label: "Figma" },
  { value: "behance", label: "Behance" },
  { value: "dribbble", label: "Dribbble" },
  { value: "video", label: "Video" },
  { value: "other", label: "Other" },
];

const newRow = () => ({ type: "web", url: "", label: "" });

const LinksEditor = ({ value = [], onChange }) => {
  const update = (i, patch) =>
    onChange(value.map((row, idx) => (idx === i ? { ...row, ...patch } : row)));
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));
  const add = () => onChange([...value, newRow()]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {value.length === 0 && (
        <div style={{ fontFamily: "var(--fw-mono)", fontSize: 11, color: "var(--fw-muted)", padding: "4px 0" }}>
          No links yet
        </div>
      )}
      {value.map((row, i) => (
        <div
          key={i}
          style={{
            display: "grid",
            gridTemplateColumns: "180px 1fr 1fr 32px",
            gap: 8,
            alignItems: "center",
          }}
        >
          <select
            className="fw-select"
            value={row.type || "web"}
            onChange={(e) => update(i, { type: e.target.value })}
          >
            {LINK_TYPES.map((t) => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
          <input
            className="fw-input"
            type="url"
            placeholder="https://"
            value={row.url || ""}
            onChange={(e) => update(i, { url: e.target.value })}
          />
          <input
            className="fw-input"
            placeholder="Custom label (optional)"
            value={row.label || ""}
            onChange={(e) => update(i, { label: e.target.value })}
          />
          <button
            type="button"
            onClick={() => remove(i)}
            aria-label="Remove link"
            style={{
              width: 32,
              height: 32,
              border: "1px solid var(--fw-line-strong)",
              background: "var(--fw-cream)",
              borderRadius: "var(--fw-r-sm)",
              cursor: "pointer",
              color: "var(--fw-red)",
              fontSize: 16,
              lineHeight: 1,
            }}
          >
            ×
          </button>
        </div>
      ))}
      <div>
        <button type="button" className="fw-btn fw-btn--ghost" onClick={add}>+ Add link</button>
      </div>
    </div>
  );
};

export default LinksEditor;
